import { render, staticRenderFns } from "./editSalary.vue?vue&type=template&id=a79f07b2&scoped=true&"
import script from "./editSalary.vue?vue&type=script&lang=js&"
export * from "./editSalary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a79f07b2",
  null
  
)

export default component.exports